<template>
  <div class="d-flex justify-content-end">
    <McTableFilter
      :activeFilters="localFilters"
      :parseFilterDataMappings="parseFilterDataMappings"
      :presetFullObjects="setFullObjects"
      :defaultValues="{
        statusCheck: ['unresolved', 'resolved', 'falseAlert'],
        sourceDeviceType: ['CAM', 'GPS'],
      }"
      @submit="handleInput"
      @update:showModal="handleShowModalChange"
      @reset="handleReset"
      @getFullObjects="updateLocalFullObjects"
    >
      <template #content="{ formValues, updateFormValues, fullObjects, updateFullObjects }">
        <div class="mc-modal__filter-item">
          <label v-if="hasAccess(['e4e-alert-center-urgent:read'])"
            >{{ $t('global.action.show') }} {{ $t('global.object.notification') }}</label
          >
          <div class="d-flex gap-2" v-if="hasAccess(['e4e-alert-center-urgent:read'])">
            <McCheckbox v-model="formValues.isUrgent" />
            <span>{{ $t('notification.text.urgentNotification') }}</span>
          </div>
          <div class="d-flex gap-2 my-2">
            <McCheckbox v-model="formValues.isImportant" />
            <span>{{ $t('notification.text.importantNotification') }}</span>
          </div>
          <div class="d-flex gap-2 my-2">
            <McCheckbox v-model="formValues.unread" />
            <span>
              {{ $t('notification.text.unread') }} ({{
                $t('notification.text.importantNotification')
              }})
            </span>
          </div>
          <!-- TODO : Remove this after issue SVCENG-3242 DONE -->
          <!-- <div class="d-flex gap-2">
            <McCheckbox v-model="formValues.shouldHaveMedia" />
            <span>{{ $t('notification.text.hasMedia') }}</span>
          </div> -->
        </div>

        <div class="mc-modal__filter-item">
          <FormulateInput
            type="group"
            name="sourceDeviceType"
            :label="$t('notification.text.sourceDevice')"
            :value="(formValues.sourceDeviceType = sourceDeviceCheck)"
          >
            <div class="mc-modal__filter-button-group">
              <template v-for="option in sourceDeviceTypeOptions">
                <button
                  :key="`${option.key}-${btnKey}`"
                  type="button"
                  :class="{ 'mc-modal__filter-button--active': sourceDeviceCheck[option.key] }"
                  class="mc-modal__filter-button"
                  @click="filterSource(option.key)"
                >
                  {{ option.label }}
                </button>
              </template>
            </div>
          </FormulateInput>
        </div>

        <div class="mc-modal__filter-item">
          <FormulateInput
            type="group"
            name="statusCheck"
            :label="$t('global.field.checkedStatus')"
            :value="(formValues.statusCheck = statusCheck)"
          >
            <div class="mc-modal__filter-button-group">
              <template v-for="option in statusOptions">
                <button
                  :key="`${option.key}-${btnKey}`"
                  type="button"
                  :class="{ 'mc-modal__filter-button--active': statusCheck[option.key] }"
                  class="mc-modal__filter-button"
                  @click="filterStatus(option.key)"
                >
                  {{ option.label }}
                </button>
              </template>
            </div>
          </FormulateInput>
        </div>

        <div class="mc-modal__filter-item">
          <FormulateInput
            v-bind="vehicleCategoryFields"
            :fullObject="fullObjects['vehicleCategory']"
            :value="formValues.vehicleCategory"
            @update:formValues="updateFormValues({ key: 'vehicleCategory', value: $event })"
            @update:fullObject="updateFullObjects({ key: 'vehicleCategory', value: $event })"
          />
        </div>
        <div class="mc-modal__filter-item">
          <FormulateInput
            v-bind="alertFields"
            :fullObject="fullObjects['alertCode']"
            :value="formValues.alertCode"
            @update:formValues="updateFormValues({ key: 'alertCode', value: $event })"
            @update:fullObject="updateFullObjects({ key: 'alertCode', value: $event })"
          />
        </div>
        <div class="mc-modal__filter-item">
          <FormulateInput
            v-bind="vehicleFields"
            :fullObject="fullObjects['licensePlate']"
            :value="formValues.licensePlate"
            @update:formValues="updateFormValues({ key: 'licensePlate', value: $event })"
            @update:fullObject="updateFullObjects({ key: 'licensePlate', value: $event })"
          />
        </div>
        <div class="mc-modal__filter-item">
          <FormulateInput
            v-bind="driverField"
            :fullObject="fullObjects['drivers']"
            :value="formValues.drivers"
            @update:formValues="updateFormValues({ key: 'drivers', value: $event })"
            @update:fullObject="updateFullObjects({ key: 'drivers', value: $event })"
          />
        </div>
      </template>
    </McTableFilter>
  </div>
</template>
<script>
import McCheckbox from '@/components/McCheckbox'
import McTableFilter from '@/components/McTableFilter'
import { Helper } from '@/mixin/helper'
import Notification from '@/mixin/notification'
import { GET_DRIVER_FILTER } from '@/services/api/master/employees'
import {
  GET_VEHICLE_FILTER,
  GET_VEHICLE_GROUPS,
  GET_VEHICLE_TYPES,
} from '@/services/api/master/fleet'
import { GET_CATEGORY } from '@/services/api/setting/fleet/fleetCat'
import cloneDeep from 'lodash/cloneDeep'
import moment from 'moment'
import { mapGetters } from 'vuex'
import { alertCategory } from '../lib/alert-code'

moment.locale('id')

export default {
  components: {
    McTableFilter,
    McCheckbox,
  },
  mixins: [Helper, Notification],
  apollo: {
    vehicleTypes: {
      query: GET_VEHICLE_TYPES,
      variables() {
        return {
          filter: {
            hasVehicle: true,
            isActive: true,
          },
        }
      },
      result({ data, loading }) {
        if (loading) return
        let vehicleTypes = { ...data.vehicleTypes }
        this.$store.commit('report/updateVehicleTypeList', {
          list: vehicleTypes.vehicleTypes.data,
          loaded: true,
        })
      },
    },
    vgroups: {
      query: GET_VEHICLE_GROUPS,
      result({ data, loading }) {
        if (loading) return
        let vgroups = { ...data.vgroups }
        this.$store.commit('report/updateVgroupList', {
          list: vgroups.vgroups,
          loaded: true,
        })
      },
    },
  },
  props: {
    activeFilters: {
      type: Object,
      required: true,
    },
    alertCode: {
      type: Array,
      required: true,
    },
    setFullObjects: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['input', 'update:fullObject'],
  data() {
    return {
      statusCheck: {
        all: true,
      },
      btnKey: 0,
      isModalVisible: false,
      localFilters: {},
      sourceDeviceCheck: {
        all: true,
      },
      vehicleTypes: {
        vehicleTypes: [],
      },
      vgroups: {
        vgroups: [],
      },
    }
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      getFeatureFlagData: 'identity/getFeatureFlagData',
    }),
    alert() {
      const data = cloneDeep(this.alertCode)
      data.forEach((item) => {
        item.label = this.$t(item.label)
      })
      data.sort((a, b) => {
        let x = a.label.toLowerCase()
        let y = b.label.toLowerCase()
        if (x < y) {
          return -1
        }
        if (x > y) {
          return 1
        }
        return 0
      })
      data.unshift({
        key: 'all',
        alertCode: null,
        label: this.$t('global.filter.all'),
        scope: null,
      })

      return data
    },
    keys() {
      return this.alertCode.map((item) => item.key)
    },
    vehicleCategoryFields() {
      return {
        name: 'vehicleCategory',
        isShow: true,
        label: this.$t('global.object.fleetCategory'),
        type: 'value-help-v2',
        placeholder: `${this.$t('global.action.choose')} ${this.$t('global.object.fleetCategory')}`,
        trackBy: 'category',
        displayedBy: 'category',
        listGetter: (opts) => this.getFleetCategoryList(opts),
        multiple: true,
        tableFields: [
          {
            label: this.$t('global.object.fleetCategory'),
            key: 'category',
            isSortable: true,
          },
        ],
      }
    },
    alertFields() {
      return {
        name: 'alertCode',
        isShow: true,
        label: this.$t('setting.list.notification.form.notificationName'),
        type: 'report-filter-value-help',
        placeholder: `${this.$t('global.action.choose')} ${this.$t('global.object.notification')}`,
        trackBy: 'id',
        displayedBy: 'label',
        listGetter: (filter) => this.getAlertList(filter),
        multiple: true,
        tableFields: [
          {
            label: this.$t('setting.list.notification.form.notificationName'),
            key: 'label',
            isSortable: false,
          },
          {
            label: this.$t('notification.text.notificationCategory'),
            key: 'category',
            isSortable: false,
            formatter: (value) => {
              if (!value || !Array.isArray(value) || value.length === 0) return '-'
              return value.join(', ')
            },
          },
        ],
        filters: [
          {
            label: `${this.$t('global.action.choose')} ${this.$t(
              'global.field.category'
            )} ${this.$t('global.object.notification')}`,
            key: 'alertCategory',
            data: this.getFilterValue(1000, 'alertCategory'),
            model: [],
          },
        ],
      }
    },
    vehicleFields() {
      const tableFields = [
        {
          label: this.$t('report.fields.licensePlate'),
          key: 'licensePlate',
          isSortable: true,
        },
        {
          label: this.$t('report.fields.vehicleGroup'),
          key: 'vehicle2Vgroup',
          isSortable: false,
          formatter: (value) => {
            return value && value.length > 0 ? value.map((v) => v.vgroup.name).join(', ') : '-'
          },
        },
      ]
      return {
        name: 'licensePlate',
        isShow: true,
        label: this.$t('report.fields.licensePlate'),
        type: 'report-filter-value-help',
        placeholder: `${this.$t('global.action.choose')} ${this.$t('report.fields.licensePlate')}`,
        trackBy: 'id',
        displayedBy: 'licensePlate',
        listGetter: (filter) => this.getVehicleList(filter),
        multiple: true,
        tableFields: tableFields,
        filters: [
          {
            label: this.$t('report.fields.vehicleGroup'),
            key: 'vgroup',
            data: this.getFilterValue(1000, 'vgroup'),
            model: [],
          },
        ],
      }
    },
    driverField() {
      return {
        name: 'drivers',
        isShow: true,
        label: this.$t('report.fields.driver'),
        type: 'report-filter-value-help',
        placeholder: `${this.$t('global.action.choose')} ${this.$t('report.fields.driver')}`,
        trackBy: 'id',
        displayedBy: 'fullname',
        listGetter: (filter) => this.getEmployeeList(filter),
        multiple: true,
        tableFields: [
          {
            label: this.$t('report.fields.driver'),
            key: 'fullname',
            isSortable: true,
          },
          {
            label: this.$t('master.form.employee.nip'),
            key: 'employeeIdentifier',
            isSortable: true,
            formatter: (value) => {
              return value ?? '-'
            },
          },
        ],
      }
    },
    vgroupList() {
      return this.$store.state.report.vGroupList
    },
    vehicleTypeList() {
      return this.$store.state.report.vehicleTypeList
    },
    status() {
      return [
        {
          key: 'unresolved',
          label: this.$t('controlTower.detail.notChecked'),
        },
        {
          key: 'resolved',
          label: this.$t('controlTower.detail.checked'),
        },
        {
          key: 'falseAlert',
          label: 'False Alert',
        },
      ]
    },
    statusOptions() {
      const data = cloneDeep(this.status)
      data.unshift({
        key: 'all',
        label: this.$t('global.filter.all'),
      })
      return data
    },
    parseFilterDataMappings() {
      return {
        vehicleCategory: 'vehicleCategory',
        alertCode: 'alertCode',
        licensePlate: 'vehicleId',
        drivers: 'driverId',
        statusCheck: 'statusCheck',
        shouldHaveMedia: 'shouldHaveMedia',
        unread: 'isRead',
        isImportant: 'isImportant',
        isUrgent: 'isUrgent',
        sourceDeviceType: 'sourceDeviceType',
      }
    },

    sourceDeviceType() {
      return [
        {
          key: 'CAM',
          label: this.$t('trackVideo.camera'),
        },
        {
          key: 'GPS',
          label: 'GPS',
        },
      ]
    },

    sourceDeviceTypeOptions() {
      const options = cloneDeep(this.sourceDeviceType)
      options.unshift({
        key: 'all',
        label: this.$t('global.filter.all'),
      })
      return options
    },
  },
  watch: {
    activeFilters: {
      handler(newValue) {
        if (newValue) {
          this.setLocalFilters(newValue)
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    setLocalFilters(filters) {
      this.localFilters = cloneDeep(filters)
      this.setStatusCheckFromFilters(filters.statusCheck)
      this.setSourceDeviceCheckFromFilters(filters.sourceDeviceType)
    },
    setStatusCheckFromFilters(statusCheckValues) {
      if (!statusCheckValues?.length) {
        this.statusCheck = { all: true }
        return
      }

      this.statusCheck = this.statusOptions.reduce((acc, item) => {
        acc[item.key] = statusCheckValues.includes(item.key)
        return acc
      }, {})

      // Set all to true if all status options are selected
      this.statusCheck.all = statusCheckValues.length === this.status.length
      if (this.statusCheck.all) {
        this.status.forEach((item) => {
          this.statusCheck[item.key] = false
        })
      }
    },
    setSourceDeviceCheckFromFilters(sourceDeviceCheckValues) {
      if (!sourceDeviceCheckValues?.length) {
        this.sourceDeviceCheck = { all: true }
        return
      }

      this.sourceDeviceCheck = this.sourceDeviceTypeOptions.reduce((acc, item) => {
        acc[item.key] = sourceDeviceCheckValues.includes(item.key)
        return acc
      }, {})

      // Set all to true if all status options are selected
      this.sourceDeviceCheck.all = sourceDeviceCheckValues.length === this.sourceDeviceType.length
      if (this.sourceDeviceCheck.all) {
        this.sourceDeviceType.forEach((item) => {
          this.sourceDeviceCheck[item.key] = false
        })
      }
    },
    getListFilterLoaded(type) {
      let loaded = false
      let list = []
      switch (type) {
        case 'vehicleType':
          list = this.vehicleTypeList.list.map((item) => {
            return {
              id: item.vehicleTypeId,
              name: `${item.manufacturer} / ${item.model} / ${item.type}`,
            }
          })
          loaded = this.vehicleTypeList.loaded
          break
        case 'vgroup':
          list = this.vgroupList.list.map((item) => {
            return { id: item.id, name: item.name }
          })
          loaded = this.vgroupList.loaded
          break
        case 'alertCategory': {
          list = alertCategory
            .filter((item) => item.scope)
            .map((item) => ({
              ...item,
              name: this.$t(item.name),
            }))
          loaded = true
          break
        }
        default:
          break
      }
      return { loaded, list }
    },
    getFilterValue(interval, type) {
      return new Promise((resolve) => {
        const { loaded, list } = this.getListFilterLoaded(type)
        if (!loaded) {
          const intervalId = setInterval(() => {
            const { loaded, list } = this.getListFilterLoaded(type)
            if (loaded) {
              clearInterval(intervalId)
              resolve(list)
            }
          }, interval)
        } else {
          resolve(list)
        }
      })
    },
    async getFleetCategoryList(opts) {
      const filter = {
        pagination: {
          page: opts.page,
          show: opts.limit,
        },
        search: opts.search,
      }

      const response = await this.$apollo.query({
        query: GET_CATEGORY,
        fetchPolicy: 'no-cache',
        variables: {
          filter: filter,
        },
      })

      const vehicleCategoryOptions = response.data.vehicleCategories.vehicleCategories

      return {
        metadata: {
          total_count: vehicleCategoryOptions.pagination.total,
          page: vehicleCategoryOptions.pagination.page,
        },
        data: {
          paginated_result: vehicleCategoryOptions.data,
        },
      }
    },
    async getVehicleList(opt) {
      const { orderBy, ...otherOpt } = opt
      const self = this
      const response = await this.$apollo.query({
        query: GET_VEHICLE_FILTER,
        variables: {
          filter: {
            status: ['I', 'R', 'A'],
            orderBy: orderBy ?? JSON.stringify({ licensePlate: 'asc' }),
            ...otherOpt,
          },
        },
      })
      let res = { ...response.data.vehiclesFilter.vehiclesFilterPaginated }
      res.data = res.data.map((item) => {
        let status = ''
        if (item.status === 'I') {
          status = self.$t('master.status.aktif')
        } else if (item.status === 'R') {
          status = self.$t('master.status.perbaikan')
        } else {
          status = self.$t('master.status.arsip')
        }
        return Object.assign({}, item, { statusString: status })
      })
      return res
    },
    async getEmployeeList(opt) {
      const { orderBy, ...otherOpt } = opt
      const response = await this.$apollo.query({
        query: GET_DRIVER_FILTER,
        variables: {
          filter: {
            isDriver: true,
            isActive: true,
            orderBy: orderBy ?? JSON.stringify({ fullname: 'asc' }),
            ...otherOpt,
          },
        },
      })
      let res = { ...response.data.driversFilter.driversFilterPaginated }

      res.data = res.data.map((item) => {
        return {
          ...item,
          id: item.userId,
        }
      })

      return res
    },
    updateLocalFullObjects(value) {
      this.$emit('applyFullObjects', value)
    },
    handleInput(value) {
      if (!value) return
      value.map((item) => {
        if (!item.values) {
          if (item.key == 'statusCheck') {
            item.values = this.status.map((item) => item.key)
          }
          if (
            item.key === 'alertCode' ||
            item.key === 'vehicleId' ||
            item.key === 'driverId' ||
            item.key === 'vehicleCategory'
          ) {
            item.values = []
          }
          if (
            item.key === 'shouldHaveMedia' ||
            item.key === 'isRead' ||
            item.key === 'isImportant' ||
            item.key === 'isUrgent'
          ) {
            item.values = false
          }
          if (item.key === 'sourceDeviceType') {
            item.values = this.sourceDeviceType.map((item) => item.key)
          }
        } else {
          if (item.key === 'alertCode') {
            item.values = this.alertCode
              .filter((alert) => item.values.includes(alert.key))
              .flatMap((res) => res.alertCode)
          }
          if (item.key === 'statusCheck') {
            item.values = this.statusCheck.all
              ? this.status.map((item) => item.key)
              : this.status.filter((item) => this.statusCheck[item.key]).map((item) => item.key)
          }
          if (item.key === 'sourceDeviceType') {
            item.values = this.sourceDeviceCheck.all
              ? this.sourceDeviceType.map((item) => item.key)
              : this.sourceDeviceType
                  .filter((item) => this.sourceDeviceCheck[item.key])
                  .map((item) => item.key)
          }
        }
      })
      this.$emit('applyFilters', value)
    },
    handleShowModalChange(value) {
      this.isModalVisible = value
      if (!this.isModalVisible && Object.keys(this.activeFilters).length === 0) {
        this.statusCheck = 'all'
        this.sourceDeviceCheck = 'all'
      }
    },
    handleReset() {
      this.$emit('applyFullObjects', {})
    },
    filterStatus(key) {
      if (key == 'all') {
        this.statusCheck = this.statusOptions.reduce((acc, item) => {
          acc[item.key] = false
          return acc
        }, {})
        this.statusCheck.all = true
      } else {
        this.statusCheck.all = false
        this.statusCheck[key] = !this.statusCheck[key]
        let obj = { ...this.statusCheck }
        let objArr = []
        Object.keys(obj).forEach(function (key) {
          if (obj[key]) {
            objArr.push(true)
          }
        })
        if (objArr.length === this.status.length || objArr.length === 0) {
          this.statusCheck = this.statusOptions.reduce((acc, item) => {
            acc[item.key] = false
            return acc
          }, {})
          this.statusCheck.all = true
          return
        }
      }
      this.btnKey += 1
    },
    filterSource(key) {
      if (key == 'all') {
        this.sourceDeviceCheck = this.sourceDeviceTypeOptions.reduce((acc, item) => {
          acc[item.key] = false
          return acc
        }, {})
        this.sourceDeviceCheck.all = true
      } else {
        this.sourceDeviceCheck.all = false
        this.sourceDeviceCheck[key] = !this.sourceDeviceCheck[key]
        let obj = { ...this.sourceDeviceCheck }
        let objArr = []
        Object.keys(obj).forEach(function (key) {
          if (obj[key]) {
            objArr.push(true)
          }
        })
        if (objArr.length === this.sourceDeviceType.length || objArr.length === 0) {
          this.sourceDeviceCheck = this.sourceDeviceTypeOptions.reduce((acc, item) => {
            acc[item.key] = false
            return acc
          }, {})
          this.sourceDeviceCheck.all = true
          return
        }
      }
      this.btnKey += 1
    },
  },
}
</script>
